(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["market-entrance-gate"] && !Shopify.designMode) return;
  try {
    (() => {
    const storageKey = 'franzi.marketGate.confirmed';
    const pendingKey = 'franzi.marketGate.pending';
    const geoipKey = 'franzi.marketGate.geoip';
    const countryKey = 'franzi.marketGate.country';
    const languageKey = 'franzi.marketGate.language';
    const sourceKey = 'franzi.marketGate.source';
    const pendingSourceKey = 'franzi.marketGate.pendingSource';
    const gate = document.querySelector('[data-market-gate]');
    const openButtons = Array.from(document.querySelectorAll('[data-market-gate-open]'));
    const page = document.querySelector('[data-market-gate-page]');

    if (!gate) return;

    const panel = gate.querySelector('.market-gate__panel');
    const countrySelect = gate.querySelector('[data-market-gate-country]');
    const languageSelect = gate.querySelector('[data-market-gate-language]');
    const form = gate.querySelector('form');
    const closeButtons = Array.from(gate.querySelectorAll('[data-market-gate-close]'));
    let previousFocus = null;
    let userInteracted = false;
    let submissionSource = 'manual';

    if (countrySelect) {
      const selectedValue = countrySelect.value;
      const options = Array.from(countrySelect.options);
      let regionNames = null;

      try {
        regionNames = new Intl.DisplayNames(['en'], { type: 'region' });
      } catch (_error) {
        regionNames = null;
      }

      options.forEach((option) => {
        const englishName = regionNames?.of(option.value);

        if (englishName && englishName !== option.value) {
          option.text = option.dataset.currency ? `${englishName} / ${option.dataset.currency}` : englishName;
        }
      });

      options.sort((a, b) => a.text.localeCompare(b.text, 'en'));

      const europeGroup = document.createElement('optgroup');
      const internationalGroup = document.createElement('optgroup');

      europeGroup.label = gate.dataset.europeLabel || 'Europe';
      internationalGroup.label = gate.dataset.internationalLabel || 'International';

      options.forEach((option) => {
        const group = option.dataset.currency === 'EUR' ? europeGroup : internationalGroup;
        group.appendChild(option);
      });

      countrySelect.replaceChildren();
      if (europeGroup.children.length) countrySelect.appendChild(europeGroup);
      if (internationalGroup.children.length) countrySelect.appendChild(internationalGroup);
      countrySelect.value = selectedValue;
    }

    const currentCountry = gate.dataset.currentCountry || '';
    const currentLanguage = gate.dataset.currentLanguage || '';
    const localeCountry = gate.dataset.localeCountry || '';

    if (readStorage(pendingKey)) {
      // The visitor (or the GeoIP pass) submitted the localization form;
      // whatever locale/country Shopify actually applied is now settled.
      writeStorage(storageKey, 'true');
      writeStorage(countryKey, currentCountry);
      writeStorage(languageKey, currentLanguage);
      writeStorage(sourceKey, readStorage(pendingSourceKey) || 'unknown');
      removeStorage(pendingKey);
      removeStorage(pendingSourceKey);
    }

    openButtons.forEach((button) => {
      button.addEventListener('click', () => {
        if (document.body.classList.contains('has-open-mobile-menu')) {
          document.querySelector('[data-mobile-menu-toggle]')?.click();
        }

        showGate();
      });
    });

    closeButtons.forEach((button) => {
      button.addEventListener('click', () => {
        hideGate();
      });
    });

    gate.addEventListener('keydown', (event) => {
      if (gate.hidden) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        hideGate();
        return;
      }

      if (event.key !== 'Tab') return;

      const focusable = focusableElements();
      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (!first || !last) return;

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    form?.addEventListener('submit', () => {
      removeStorage(storageKey);
      writeStorage(pendingKey, 'true');
      writeStorage(pendingSourceKey, submissionSource);
    });

    const localeHandled = maybeLocalizeByLocale();
    if (!localeHandled) maybeLocalizeByGeoip();

    function showGate() {
      userInteracted = true;
      previousFocus = document.activeElement;
      gate.hidden = false;
      setModalState(true);
      window.requestAnimationFrame(() => {
        const target = countrySelect || panel || focusableElements()[0];
        target?.focus();
      });
    }

    function hideGate() {
      gate.hidden = true;
      setModalState(false);

      if (previousFocus instanceof HTMLElement) {
        previousFocus.focus();
      }

      previousFocus = null;
    }

    function setModalState(isOpen) {
      if (page) {
        page.toggleAttribute('inert', isOpen);
        if (isOpen) {
          page.setAttribute('aria-hidden', 'true');
        } else {
          page.removeAttribute('aria-hidden');
        }
      }

      document.documentElement.toggleAttribute('data-market-gate-active', isOpen);
    }

    function readStorage(key) {
      try {
        return window.localStorage.getItem(key);
      } catch (_error) {
        return null;
      }
    }

    function writeStorage(key, value) {
      try {
        window.localStorage.setItem(key, value);
        return true;
      } catch (_error) {
        return false;
      }
    }

    function removeStorage(key) {
      try {
        window.localStorage.removeItem(key);
      } catch (_error) {
        // Storage is blocked; the gate still works without persistence.
      }
    }

    function focusableElements() {
      if (!panel) return [];

      return Array.from(
        panel.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
        ),
      ).filter((element) => element instanceof HTMLElement && element.offsetParent !== null);
    }

    function maybeLocalizeByLocale() {
      if (!localeCountry) return false;

      const confirmedLanguage = readStorage(languageKey);
      const confirmedSource = readStorage(sourceKey);
      const hasConfirmedChoice = readStorage(storageKey) === 'true';
      if (hasConfirmedChoice && confirmedSource === 'manual' && confirmedLanguage === currentLanguage) return false;
      if (window.Shopify?.designMode) return true;
      if (navigator.webdriver || /bot|crawl|spider|slurp|bingpreview/i.test(navigator.userAgent)) return true;
      if (currentCountry === localeCountry) return true;
      if (!countrySelect || !form) return true;

      const hasCountryOption = Array.from(countrySelect.options).some((option) => option.value === localeCountry);
      if (!hasCountryOption) return true;
      if (!writeStorage(pendingKey, 'true')) return true;

      submissionSource = 'locale';
      writeStorage(pendingSourceKey, submissionSource);
      removeStorage(storageKey);
      countrySelect.value = localeCountry;

      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.submit();
      }

      return true;
    }

    function maybeLocalizeByGeoip() {
      if (!gate.hasAttribute('data-market-gate-geoip')) return;
      if (window.Shopify?.designMode) return;
      if (navigator.webdriver || /bot|crawl|spider|slurp|bingpreview/i.test(navigator.userAgent)) return;
      if (readStorage(storageKey) === 'true') return;
      if (readStorage(geoipKey)) return;

      fetch('/browsing_context_suggestions.json?country%5Benabled%5D=true&language%5Benabled%5D=true', {
        headers: { accept: 'application/json' },
      })
        .then((response) => (response.ok ? response.json() : null))
        .then((payload) => {
          if (!payload) return;
          // The visitor touched the gate while the lookup was in flight —
          // their explicit choice wins over the detected one.
          if (userInteracted || !gate.hidden) return;
          // The one-shot flag is also the storage probe: if it can't
          // persist, auto-submitting would repeat on every page load.
          if (!writeStorage(geoipKey, 'true')) return;

          const parts = payload.suggestions?.[0]?.parts;
          const suggestedCountry = parts?.country?.handle || payload.detected_values?.country?.handle || '';
          let suggestedLanguage = parts?.language?.handle || '';

          // Never override an explicitly chosen non-default locale (e.g. a
          // shared /en link): only switch language while on the primary one.
          if (gate.dataset.primaryLanguage !== 'true') suggestedLanguage = '';

          const hasCountryOption =
            !!countrySelect && Array.from(countrySelect.options).some((option) => option.value === suggestedCountry);
          const hasLanguageOption =
            !!languageSelect && Array.from(languageSelect.options).some((option) => option.value === suggestedLanguage);

          const nextCountry = hasCountryOption && suggestedCountry !== currentCountry ? suggestedCountry : '';
          const nextLanguage = hasLanguageOption && suggestedLanguage !== currentLanguage ? suggestedLanguage : '';

          if (!nextCountry && !nextLanguage) return;
          if (!form) return;

          if (countrySelect && nextCountry) countrySelect.value = nextCountry;
          if (languageSelect && nextLanguage) languageSelect.value = nextLanguage;

          submissionSource = 'geoip';
          writeStorage(pendingKey, 'true');
          writeStorage(pendingSourceKey, submissionSource);

          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
          } else {
            form.submit();
          }
        })
        .catch(() => {});
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
